import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import "../assets/css/benefits.css";
import CloseImage from "../assets/images/close.svg";
import ModalImageDescription from "./modalImageDescription";
import { useSelector, useDispatch } from 'react-redux';
import { getRewardSections } from '../redux/data/dataActions';
import { setPhoneNumber, setTermsAndConditions } from '../redux/data/dataSlice';

function RewardModal(props) {
    const dispatch = useDispatch();
    const [getCodeClicked, setGetCodeClicked] = useState(false);
    const tabSelected = useSelector(state => state.data.tabSelected);

    // Modal Analytics
    useEffect(() => {
        if (window._satellite) {
            if (props.selectedReward && props.selectedReward) {
                let data = {
                    modalName: `nba:membership-hub:${tabSelected}-detail`,
                    contentTitle: props.selectedReward.title,
                    contentID: "",
                    contentType: "benefit",
                };
                window._satellite.track("modal-display", data);
                console.log("Reward Modal: analytics added");
            }
        }
    }, [props.selectedReward, tabSelected]);

    return (
        <>
            <div className="modal-header">
                <Link
                    to={{
                        pathname: `/${tabSelected}`,
                        search: window.location.search.includes("cl=1") ? window.location.search.replace("&cl=1", "") : window.location.search
                    }}
                    className="modal-close"
                    data-track="click"
                    data-id="nba:membership-hub:dismiss"
                    data-section={tabSelected}
                    data-type="dismiss"
                    onClick={() => {
                        props.setShowModal(false);
                        dispatch(setPhoneNumber(""));
                        dispatch(setTermsAndConditions(false));
                        dispatch(getRewardSections(tabSelected));
                        if (props.close) {
                            props.close();
                        }
                    }}>
                    <img alt="close" src={CloseImage} />
                </Link>
            </div>
            <div className="modal-header-title">
                {props.selectedReward.title}
            </div>
            <div className="modal-header-separator"></div>
            <div className="modal-body">
                <ModalImageDescription reward={props.selectedReward} getCodeClicked={getCodeClicked} setGetCodeClicked={setGetCodeClicked} setShowModal={props.setShowModal} />
            </div>
        </>
    );
}

export default RewardModal;
